"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryAllBridgeResponse = exports.QueryAllBridgeRequest = exports.QueryGetBridgeResponse = exports.QueryGetBridgeRequest = exports.QueryTotalBalancesResponse = exports.QueryTotalBalancesRequest = exports.QueryGetBalancesResponse = exports.QueryGetBalancesRequest = exports.QueryAllWrapperMappingsResponse_WrapperMappingsEntry = exports.QueryAllWrapperMappingsResponse = exports.QueryAllWrapperMappingsRequest = exports.QueryGetLockedCoinsResponse = exports.QueryGetLockedCoinsRequest = exports.QueryAllTokenResponse = exports.QueryAllTokenRequest = exports.QueryGetTokenResponse = exports.QueryGetTokenRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const token_1 = require("../coin/token");
const pagination_1 = require("../cosmos/base/query/v1beta1/pagination");
const bridge_1 = require("../coin/bridge");
exports.protobufPackage = "Switcheo.carbon.coin";
const baseQueryGetTokenRequest = { denom: "" };
exports.QueryGetTokenRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetTokenRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetTokenRequest);
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryGetTokenRequest);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryGetTokenResponse = {};
exports.QueryGetTokenResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.token !== undefined) {
            token_1.Token.encode(message.token, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetTokenResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.token = token_1.Token.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetTokenResponse);
        message.token =
            object.token !== undefined && object.token !== null
                ? token_1.Token.fromJSON(object.token)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.token !== undefined &&
            (obj.token = message.token ? token_1.Token.toJSON(message.token) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetTokenResponse);
        message.token =
            object.token !== undefined && object.token !== null
                ? token_1.Token.fromPartial(object.token)
                : undefined;
        return message;
    },
};
const baseQueryAllTokenRequest = {};
exports.QueryAllTokenRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllTokenRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllTokenRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllTokenRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllTokenResponse = {};
exports.QueryAllTokenResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.tokens) {
            token_1.Token.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllTokenResponse);
        message.tokens = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokens.push(token_1.Token.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllTokenResponse);
        message.tokens = ((_a = object.tokens) !== null && _a !== void 0 ? _a : []).map((e) => token_1.Token.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tokens) {
            obj.tokens = message.tokens.map((e) => (e ? token_1.Token.toJSON(e) : undefined));
        }
        else {
            obj.tokens = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllTokenResponse);
        message.tokens = ((_a = object.tokens) !== null && _a !== void 0 ? _a : []).map((e) => token_1.Token.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryGetLockedCoinsRequest = { address: "" };
exports.QueryGetLockedCoinsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetLockedCoinsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetLockedCoinsRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryGetLockedCoinsRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryGetLockedCoinsResponse = {};
exports.QueryGetLockedCoinsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.lockedCoins) {
            token_1.LockedCoins.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetLockedCoinsResponse);
        message.lockedCoins = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.lockedCoins.push(token_1.LockedCoins.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryGetLockedCoinsResponse);
        message.lockedCoins = ((_a = object.lockedCoins) !== null && _a !== void 0 ? _a : []).map((e) => token_1.LockedCoins.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.lockedCoins) {
            obj.lockedCoins = message.lockedCoins.map((e) => e ? token_1.LockedCoins.toJSON(e) : undefined);
        }
        else {
            obj.lockedCoins = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryGetLockedCoinsResponse);
        message.lockedCoins = ((_a = object.lockedCoins) !== null && _a !== void 0 ? _a : []).map((e) => token_1.LockedCoins.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllWrapperMappingsRequest = {};
exports.QueryAllWrapperMappingsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllWrapperMappingsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllWrapperMappingsRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllWrapperMappingsRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllWrapperMappingsResponse = {};
exports.QueryAllWrapperMappingsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        Object.entries(message.wrapperMappings).forEach(([key, value]) => {
            exports.QueryAllWrapperMappingsResponse_WrapperMappingsEntry.encode({ key: key, value }, writer.uint32(10).fork()).ldelim();
        });
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllWrapperMappingsResponse);
        message.wrapperMappings = {};
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    const entry1 = exports.QueryAllWrapperMappingsResponse_WrapperMappingsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.wrapperMappings[entry1.key] = entry1.value;
                    }
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllWrapperMappingsResponse);
        message.wrapperMappings = Object.entries((_a = object.wrapperMappings) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            acc[key] = String(value);
            return acc;
        }, {});
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        obj.wrapperMappings = {};
        if (message.wrapperMappings) {
            Object.entries(message.wrapperMappings).forEach(([k, v]) => {
                obj.wrapperMappings[k] = v;
            });
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllWrapperMappingsResponse);
        message.wrapperMappings = Object.entries((_a = object.wrapperMappings) !== null && _a !== void 0 ? _a : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllWrapperMappingsResponse_WrapperMappingsEntry = {
    key: "",
    value: "",
};
exports.QueryAllWrapperMappingsResponse_WrapperMappingsEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllWrapperMappingsResponse_WrapperMappingsEntry);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllWrapperMappingsResponse_WrapperMappingsEntry);
        message.key =
            object.key !== undefined && object.key !== null ? String(object.key) : "";
        message.value =
            object.value !== undefined && object.value !== null
                ? String(object.value)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryAllWrapperMappingsResponse_WrapperMappingsEntry);
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseQueryGetBalancesRequest = { address: "" };
exports.QueryGetBalancesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetBalancesRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetBalancesRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryGetBalancesRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryGetBalancesResponse = {};
exports.QueryGetBalancesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.tokenBalances) {
            token_1.TokenBalance.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetBalancesResponse);
        message.tokenBalances = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tokenBalances.push(token_1.TokenBalance.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryGetBalancesResponse);
        message.tokenBalances = ((_a = object.tokenBalances) !== null && _a !== void 0 ? _a : []).map((e) => token_1.TokenBalance.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.tokenBalances) {
            obj.tokenBalances = message.tokenBalances.map((e) => e ? token_1.TokenBalance.toJSON(e) : undefined);
        }
        else {
            obj.tokenBalances = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryGetBalancesResponse);
        message.tokenBalances = ((_a = object.tokenBalances) !== null && _a !== void 0 ? _a : []).map((e) => token_1.TokenBalance.fromPartial(e));
        return message;
    },
};
const baseQueryTotalBalancesRequest = { endBlockHeight: "" };
exports.QueryTotalBalancesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.endBlockHeight !== "") {
            writer.uint32(10).string(message.endBlockHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryTotalBalancesRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.endBlockHeight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryTotalBalancesRequest);
        message.endBlockHeight =
            object.endBlockHeight !== undefined && object.endBlockHeight !== null
                ? String(object.endBlockHeight)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.endBlockHeight !== undefined &&
            (obj.endBlockHeight = message.endBlockHeight);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryTotalBalancesRequest);
        message.endBlockHeight = (_a = object.endBlockHeight) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryTotalBalancesResponse = {};
exports.QueryTotalBalancesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.balances) {
            token_1.TokenBalance.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryTotalBalancesResponse);
        message.balances = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balances.push(token_1.TokenBalance.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryTotalBalancesResponse);
        message.balances = ((_a = object.balances) !== null && _a !== void 0 ? _a : []).map((e) => token_1.TokenBalance.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.balances) {
            obj.balances = message.balances.map((e) => e ? token_1.TokenBalance.toJSON(e) : undefined);
        }
        else {
            obj.balances = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryTotalBalancesResponse);
        message.balances = ((_a = object.balances) !== null && _a !== void 0 ? _a : []).map((e) => token_1.TokenBalance.fromPartial(e));
        return message;
    },
};
const baseQueryGetBridgeRequest = {
    bridgeId: long_1.default.UZERO,
    chainId: long_1.default.UZERO,
};
exports.QueryGetBridgeRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.bridgeId.isZero()) {
            writer.uint32(8).uint64(message.bridgeId);
        }
        if (!message.chainId.isZero()) {
            writer.uint32(16).uint64(message.chainId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetBridgeRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeId = reader.uint64();
                    break;
                case 2:
                    message.chainId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetBridgeRequest);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromString(object.chainId)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined &&
            (obj.chainId = (message.chainId || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetBridgeRequest);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? long_1.default.fromValue(object.chainId)
                : long_1.default.UZERO;
        return message;
    },
};
const baseQueryGetBridgeResponse = {};
exports.QueryGetBridgeResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.bridge !== undefined) {
            bridge_1.Bridge.encode(message.bridge, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryGetBridgeResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridge = bridge_1.Bridge.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryGetBridgeResponse);
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromJSON(object.bridge)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.bridge !== undefined &&
            (obj.bridge = message.bridge ? bridge_1.Bridge.toJSON(message.bridge) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryGetBridgeResponse);
        message.bridge =
            object.bridge !== undefined && object.bridge !== null
                ? bridge_1.Bridge.fromPartial(object.bridge)
                : undefined;
        return message;
    },
};
const baseQueryAllBridgeRequest = {};
exports.QueryAllBridgeRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllBridgeRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllBridgeRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllBridgeRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllBridgeResponse = {};
exports.QueryAllBridgeResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.bridges) {
            bridge_1.Bridge.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllBridgeResponse);
        message.bridges = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridges.push(bridge_1.Bridge.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllBridgeResponse);
        message.bridges = ((_a = object.bridges) !== null && _a !== void 0 ? _a : []).map((e) => bridge_1.Bridge.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.bridges) {
            obj.bridges = message.bridges.map((e) => e ? bridge_1.Bridge.toJSON(e) : undefined);
        }
        else {
            obj.bridges = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllBridgeResponse);
        message.bridges = ((_a = object.bridges) !== null && _a !== void 0 ? _a : []).map((e) => bridge_1.Bridge.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Token = this.Token.bind(this);
        this.TokenQueryParams = this.TokenQueryParams.bind(this);
        this.TokenAll = this.TokenAll.bind(this);
        this.LockedCoins = this.LockedCoins.bind(this);
        this.WrapperMappings = this.WrapperMappings.bind(this);
        this.Balances = this.Balances.bind(this);
        this.BalancesTotal = this.BalancesTotal.bind(this);
        this.Bridge = this.Bridge.bind(this);
        this.BridgeAll = this.BridgeAll.bind(this);
    }
    Token(request) {
        const data = exports.QueryGetTokenRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Query", "Token", data);
        return promise.then((data) => exports.QueryGetTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    TokenQueryParams(request) {
        const data = exports.QueryGetTokenRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Query", "TokenQueryParams", data);
        return promise.then((data) => exports.QueryGetTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    TokenAll(request) {
        const data = exports.QueryAllTokenRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Query", "TokenAll", data);
        return promise.then((data) => exports.QueryAllTokenResponse.decode(new minimal_1.default.Reader(data)));
    }
    LockedCoins(request) {
        const data = exports.QueryGetLockedCoinsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Query", "LockedCoins", data);
        return promise.then((data) => exports.QueryGetLockedCoinsResponse.decode(new minimal_1.default.Reader(data)));
    }
    WrapperMappings(request) {
        const data = exports.QueryAllWrapperMappingsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Query", "WrapperMappings", data);
        return promise.then((data) => exports.QueryAllWrapperMappingsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Balances(request) {
        const data = exports.QueryGetBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Query", "Balances", data);
        return promise.then((data) => exports.QueryGetBalancesResponse.decode(new minimal_1.default.Reader(data)));
    }
    BalancesTotal(request) {
        const data = exports.QueryTotalBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Query", "BalancesTotal", data);
        return promise.then((data) => exports.QueryTotalBalancesResponse.decode(new minimal_1.default.Reader(data)));
    }
    Bridge(request) {
        const data = exports.QueryGetBridgeRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Query", "Bridge", data);
        return promise.then((data) => exports.QueryGetBridgeResponse.decode(new minimal_1.default.Reader(data)));
    }
    BridgeAll(request) {
        const data = exports.QueryAllBridgeRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.coin.Query", "BridgeAll", data);
        return promise.then((data) => exports.QueryAllBridgeResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
